// Lucide "archive" icon (ISC license, https://lucide.dev), inlined to match this
// project's existing pattern of hand-inlined icon SVGs (see DoubleArrowIcon.tsx).
const ArchiveIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="20" height="5" x="2" y="3" rx="1"></rect>
        <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"></path>
        <path d="M10 12h4"></path>
    </svg>
);

export default ArchiveIcon;
